import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';

import { Observable } from 'rxjs';
import { EnumSiNoTodos, Tc } from 'src/app/components/core/_infrastructure/types/common';
import { FilterSearchingRecintoUnidadInspeccion, RecintoUnidadInspeccionItemResultsViewModel } from './buscador-unidad-inspeccion.types';
import { ResetFiltersService } from 'src/app/components/core/_infrastructure/classes/services/reset-filters.service';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';

@Injectable()
export class BuscadorUnidadInspeccionService extends ResetFiltersService {
    private recintoUnidadInspeccionEndpoint = this.baseUrl + 'api/campanias/recintounidadinspeccion/';
    private arrBooleanKeys = ['Activa', 'Autorizado'];
    private arrKeysToDiscard = ['Campania', 'Periodo', 'DescripcionComunidad', 'EntidadAuditora', 'TipoRecinto']; // Estas propiedades están en el formulario pero no es necesario enviarlas

    public currentFilterUnidadInspeccion = new FilterSearchingRecintoUnidadInspeccion();
    private lastSearch?: FilterSearchingRecintoUnidadInspeccion;

    constructor(
        protected authService: AuthService,
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {
        super(authService);
    }

    /**
     * Creates an HttpParms object through the values in the parameter.
     * @param payload FilterSearchingUnidadInspeccion
     * @returns HttpParams
     */
    private convertModelToHttpParms(payload: FilterSearchingRecintoUnidadInspeccion): HttpParams {
        let params = new HttpParams();
        let k: keyof FilterSearchingRecintoUnidadInspeccion;

        for (k in payload) {
            let v: string | number | boolean | Date;
            if (this.arrKeysToDiscard.indexOf(k) !== -1) {
                continue;
            }
            let valor = payload[k];
            if (this.arrBooleanKeys.indexOf(k) !== -1 && valor == EnumSiNoTodos.NO) {
                v = 0;
            } else if (valor instanceof Date) {
                v = (valor as Date).toLocaleDateString();
            } else {
                v = valor + '' || '';
            }
            params = params.append(k, v);
        }

        return params;
    }

    /**
     * Invokes the service to get the list of "Unidades de Inspección", applying the filter in the parameter
     * @param payload FilterSearchingRecintoUnidadInspeccion
     * @returns Observable<RecintoUnidadInspeccionItemResultsViewModel>
     */
    getRecintoUnidadesInspeccion(payload: FilterSearchingRecintoUnidadInspeccion): Observable<RecintoUnidadInspeccionItemResultsViewModel> {
        this.lastSearch = { ...payload }; // Keep for future search
        const params = this.convertModelToHttpParms(this.lastSearch);
        return this.getRecintoUnidadesInspeccionPagedByFilter(params);
    }

    /**
     * Invokes the service to get the list of "Recinto-UI", applying the filter in the parameter
     * @param params HttpParams
     * @returns Observable<RecintoUnidadInspeccionItemResultsViewModel>
     */
    private getRecintoUnidadesInspeccionPagedByFilter(params: HttpParams): Observable<RecintoUnidadInspeccionItemResultsViewModel> {
        return this.http.get<RecintoUnidadInspeccionItemResultsViewModel>(this.recintoUnidadInspeccionEndpoint + 'PagedByFilter/', { params: params });
    }

    getRecintoUIOperadores(payload: any): Observable<Tc[]> {
        const params = this.convertModelToHttpParms(payload);
        return this.http.get<Tc[]>(this.recintoUnidadInspeccionEndpoint + 'Operadores/', { params: params }).pipe();
    }

    export(model: FilterSearchingRecintoUnidadInspeccion): Observable<HttpResponse<Blob>> {
        return this.http.post(this.recintoUnidadInspeccionEndpoint + 'postExportExcelByFilter', model, { observe: 'response', responseType: 'blob' });
    }

    getLastSearch(): FilterSearchingRecintoUnidadInspeccion | undefined {
        return this.lastSearch;
    }

    setLastSearch(payloadForSearching: FilterSearchingRecintoUnidadInspeccion): void {
        this.lastSearch = payloadForSearching;
    }

    resetFilter(): void {
        this.lastSearch = undefined;
    }
}
